exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tenants-list{margin-bottom:2em;margin-top:2em}.tenants-list .tenants-label{color:#646464;margin-bottom:.8em}.tenants-list .tenants-label small{font-weight:700;font-size:.75em}", ""]);

// exports
